import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { Tooltip } from 'tdesign-react';

/**
 * 如出现省略号，则tooltip展示
 * @param {Object} props props
 * @param {any} props.children
 * @returns
 */
export default function EllipsisTip({ children, ...others }) {
  const ref = useRef(null);
  const rootRef = useRef(null);
  const [isEllipsis, setIsEllipsis] = useState(false);

  const checkIsEllipsis = () => {
    const dom = ref.current;
    let isEll = false;
    if (dom) {
      isEll = dom.offsetWidth < dom.scrollWidth;
    }

    setIsEllipsis(isEll);
  };

  useEffect(() => {
    checkIsEllipsis();
    window.addEventListener('resize', checkIsEllipsis);
    return () => {
      window.removeEventListener('resize', checkIsEllipsis);
    };
  }, [children]);

  return (
    <Root ref={rootRef}>
      <Tooltip content={isEllipsis ? children : null} theme='light' attach={rootRef.current}>
        <Container ref={ref} {...others}>
          {children}
        </Container>
      </Tooltip>
    </Root>
  );
}

const Root = styled.div`
  .t-popup__content {
    word-break: break-all;
    white-space: normal;
    min-width: 300px;
  }
`;

const Container = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
